import { Address } from "@/Common/Api/Contacts/Dto/Address";
import { useTranslation } from "@/Common/CustomHooks/useTranslation";
import { ContactRenderHelper } from "@/Common/Helpers/ContactRenderHelper";
import { ValidationHelper } from "@/Common/Helpers/ValidationHelper";

import styles from "./AddressesView.module.scss";

interface IAddressesViewProps {
    addresses: Address[];
}

function AddressesView(props: IAddressesViewProps): JSX.Element {
    const validationHelper = new ValidationHelper();
    const { getText } = useTranslation();

    const listView: JSX.Element = (
        <>
            {props.addresses.map(address => {
                const validationRule = validationHelper.getPostalCodeValidationRule(address.CountryLookupId, null);
                const displayFormatSelector = validationRule?.DisplayFormatSelectorPatern ?? "";
                const displayFormatSubstitution = validationRule?.DisplayFormatSubstitution ?? "";
                const formattedPostalCode = validationHelper.getFormatedString(address.ZipCode, displayFormatSelector, displayFormatSubstitution);

                return (
                    <tbody key={`address_${address.ContactPoint_id}`} className={styles.address}>
                        {ContactRenderHelper.renderRow(
                            getText("AddressTypeLabel"),
                            cacheStore.GetLocalizedValueByLookupId(address.ContactPointTypeLookupId),
                            "patientProfile-contacts-address-type"
                        )}
                        {ContactRenderHelper.renderRow(
                            getText("StreetAddressLabel"),
                            address.StreetAddress,
                            "patientProfile-contacts-address-street"
                        )}
                        {ContactRenderHelper.renderRow(
                            getText("CityLabel"),
                            address.City,
                            "patientProfile-contacts-address-city"
                        )}
                        {ContactRenderHelper.renderRow(
                            getText("CountryLabel"),
                            cacheStore.GetLocalizedValueByLookupId(address.CountryLookupId),
                            "patientProfile-contacts-address-country"
                        )}
                        {ContactRenderHelper.renderRow(
                            getText("StateProvinceLabel"),
                            cacheStore.GetLocalizedValueByLookupId(address.StateLookupId),
                            "patientProfile-contacts-address-state"
                        )}
                        {ContactRenderHelper.renderRow(
                            getText("ZipPostalCodeLabel"),
                            formattedPostalCode,
                            "patientProfile-contacts-address-postalCode"
                        )}
                    </tbody>
                );
            })}
        </>
    );

    return (
        <>
            <div><span>{getText("AddressLabel")}</span></div>
            <div>
                <table>
                    {props.addresses.any() ? listView : ContactRenderHelper.renderEmptyView("addresses")}
                </table>
            </div>
        </>
    );
}

export { AddressesView };
